<app-internal-page backRouterLink="../">
  <div content>
    <form [formGroup]="form" autocomplete="off">
      <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.xs="20px">
        <span class="mat-title">Resumo do agendamento:</span>
        <mat-card>
          <mat-card-content>
            <div
              class="summary-container-check-list"
              fxLayout="row"
              fxLayoutAlign="center"
            >
              <div
                fxFlex="90%"
                fxFlex.xs="100%"
                fxLayout="column"
                fxLayoutGap="8px"
              >
                <div
                  fxLayoutGap="10px"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <span class="icon fa fa-check"></span>
                  <span class="mat-subheading-1">{{
                    getScheduleTypeName()
                  }}</span>
                </div>
                <div
                  fxLayoutGap="10px"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <span class="icon fa fa-check"></span>
                  <span class="mat-subheading-1">
                    {{ publicScheduleData.dentist?.name }}
                    <span *ngIf="publicScheduleData.dentist?.specialty">
                      - {{ publicScheduleData.dentist?.specialty }}
                    </span>
                  </span>
                </div>
                <div
                  fxLayoutGap="10px"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <span class="icon fa fa-check"></span>
                  <span class="mat-subheading-1">
                    {{
                      publicScheduleData.available_hour?.start_time
                        | date : "dd/MM/yyyy, EEEE, HH:mm" : "+0000"
                    }}
                  </span>
                </div>
                <div
                  fxLayoutGap="10px"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <span class="icon fa fa-check"></span>
                  <span class="mat-subheading-1">{{
                    publicScheduleData.clinic?.name
                  }}</span>
                </div>
                <div
                  fxLayoutGap="10px"
                  fxLayout="row"
                  *ngIf="publicScheduleData.clinic?.addressFormated"
                >
                  <span class="icon fa fa-check"></span>
                  <span class="mat-subheading-1">{{
                    publicScheduleData.clinic?.addressFormated
                  }}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div fxLayout="column" fxLayoutGap="5px">
          <mat-form-field appearance="outline">
            <mat-label>Nome e sobrenome</mat-label>
            <input
              matInput
              type="text"
              formControlName="name"
              autocomplete="off"
            />
            <mat-error *ngIf="form.controls['name'].hasError('required')">
              Nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Número do celular</mat-label>
            <input
              matInput
              mask="(00) 00000-0000"
              type="text"
              formControlName="cellphone"
              autocomplete="off"
              [dropSpecialCharacters]="false"
            />
            <mat-error *ngIf="form.controls['cellphone'].hasError('required')">
              Celular é obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div
          class="accept-terms-container"
          fxLayoutAlign="start start"
          fxLayoutGap="10px"
        >
          <mat-checkbox color="primary" formControlName="acceptTerms"></mat-checkbox>
          <label class="term-check-description">
            Declaro que li os termos de uso e concordo com a
            <strong (click)="onPoliticClick()">política de privacidade</strong>.
          </label>
        </div>

        <div class="politic-container" *ngIf="showPolitic">
          <app-summary-terms></app-summary-terms>
        </div>

        <button
          mat-raised-button
          color="primary"
          (click)="onClick()"
          [disabled]="form.invalid"
        >
          Confirmar agendamento
        </button>
      </div>
    </form>
  </div>
</app-internal-page>
